/**
 * The types a contact can give a supporting document. The portal offers them in this
 * order, and the API accepts no other value.
 */
export const DOCUMENT_TYPES = [
  'Annual report', 'Financial statements', 'Management accounts', 'Press release',
  'Term sheet extract', 'Shareholder register', 'Organisation chart', 'Other',
] as const

export type DocumentType = (typeof DOCUMENT_TYPES)[number]

/**
 * The file types a contact can upload: each extension, in the portal order, with the MIME
 * types that agree with it. The portal file picker and the API both read this list.
 * A CSV file can have the Excel type, because Windows gives that type to a CSV file when
 * Excel is installed.
 */
export const UPLOAD_FILE_TYPES: Readonly<Record<string, readonly string[]>> = {
  pdf: ['application/pdf'],
  doc: ['application/msword'],
  docx: ['application/vnd.openxmlformats-officedocument.wordprocessingml.document'],
  xls: ['application/vnd.ms-excel'],
  xlsx: ['application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'],
  csv: ['text/csv', 'application/vnd.ms-excel'],
  png: ['image/png'],
  jpg: ['image/jpeg'],
  jpeg: ['image/jpeg'],
}

/** The `accept` value of the portal file picker. */
export const UPLOAD_ACCEPT = Object.keys(UPLOAD_FILE_TYPES).map((ext) => `.${ext}`).join(',')

/** The lower-case text after the last dot of a file name, or '' when there is none. */
export function uploadExtensionOf(fileName: string): string {
  const dot = fileName.lastIndexOf('.')
  return dot >= 0 ? fileName.slice(dot + 1).toLowerCase() : ''
}
